import {Component, Input, OnInit} from '@angular/core';
import {InnerMessage} from '@shared/service/inner-messages.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {Subscription} from 'rxjs';
import {MessageManagerService} from '@shared/service/message-manager/message-manager.service';
import {MessageModel} from '@shared/service/message-manager/message.model';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
	selector: 'amd-message-manager',
	templateUrl: './message-manager.component.html',
	styleUrls: ['./message-manager.component.scss'],
	animations: [
		trigger('visibilityChanged', [
			state('shown', style({opacity: 1, visibility: 'visible'})),
			state('hidden', style({opacity: 0, height: '0px', visibility: 'hidden'})),
			transition('* => *', animate('300ms')),
		])
	]
})
export class MessageManagerComponent implements OnInit {
	@Input() isTop: boolean = true;

	MAX_MES: number = 1;
	messageManagerSubscription: Subscription;
	removeMessageManagerInstanceSubscription: Subscription;
	messages: Map<string, MessageModel>;
	messageValues: MessageModel[];

	constructor(public messageManagerService: MessageManagerService) {
		this.messages = new Map<string, MessageModel>();
		this.messageManagerSubscription = this.messageManagerService.pushInnerMessagesObservable.subscribe(
			inMes => {
				if (!!inMes) {
					if (this.isTop === inMes.isTop) {
						if (Utilities.isVoid(this.messages.get(inMes.id))) {
							inMes.state = 'shown';
							this.messages.set(inMes.id, inMes);
							if (inMes.autoDeleteEnable) {
								this.autoDeleteOldMessage(inMes.id);
							}
							if (this.messages.size > this.MAX_MES) {
								const keys: string[] = Array.from(this.messages.keys());
								this.messages.delete(keys[0]);
							}
						}
					}
				}
			});
		this.removeMessageManagerInstanceSubscription = this.messageManagerService.removeInnerMessagesObservable.subscribe(
			key => {
				if (!Utilities.isVoid(key)) {
					if (key === InnerMessage.DELETE_ALL) {
						this.deleteAllMessages();
					} else {
						this.deleteMessage(key);
					}
				}
			});
	}

	ngOnInit(): void {
		this.getMessagesList();
	}

	ngOnDestroy(): void {
		if (this.messageManagerSubscription) {
			this.messageManagerSubscription.unsubscribe();
		}
		if (this.removeMessageManagerInstanceSubscription) {
			this.removeMessageManagerInstanceSubscription.unsubscribe();
		}
	}

	autoDeleteOldMessage(key: string): void {
		setTimeout(() => {
			this.deleteMessage(key);
		}, (this.messages.get(key) ? this.messages.get(key).autoDeleteDelay : MessageModel.DELAY));
	}

	deleteMessage(key: string): void {
		const mess: MessageModel = this.messages.get(key);
		if (!Utilities.isVoid(mess)) {
			mess.state = 'hidden';
			setTimeout(() => {
				mess.removing = true;
				this.messages.delete(key);
			}, 310);
		}
	}

	getMessagesList(): MessageModel[] {
		this.messageValues = this.messages ? Array.from(this.messages.values()) : [];
		return this.messageValues;
	}

	private deleteAllMessages(): void {
		const keyList: string[] = Array.from(this.messages.keys());
		keyList.forEach(key => {
			if (!this.messages.get(key).keepAlive) {
				this.deleteMessage(key);
			} else {
				this.messages.get(key).keepAlive = false;
			}
		});
	}
}
